Mosaic.setPlugins([require('./../../webpack-i18n-runtime/src/plugin/App.plugin.js'),
require('./../../../../packages/extcatalog/src/plugin/ProductList.query.plugin.js'),
require('./../../../../packages/extcatalog/src/plugin/UrlRewrites.component.plugin.js'),
require('./../../../../packages/extcatalog/src/plugin/UrlRewrites.container.plugin.js'),
require('./../../../../packages/extcatalog/src/plugin/UrlRewrites.query.plugin.js'),
require('./../../../../packages/scandi-cw-payment/src/plugin/Cart.dispatcher.plugin.js'),
require('./../../../../packages/scandi-cw-payment/src/plugin/Checkout.component.plugin.js'),
require('./../../../../packages/scandi-cw-payment/src/plugin/Checkout.container.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/Field.component.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/Field.container.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/MyAccountAddressForm.component.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/MyAccountAddressForm.container.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/MyAccountAddressForm.form.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/MyAccountAddressTable.component.plugin.js'),
require('./../../../@insign/scandipwa-swiss-post/src/plugin/MyAccountAddressTable.container.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/config/ConfigDispatcher.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/config/ConfigReducer.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/content-type/Buttons.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/content-type/Map.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/content-type/Slider.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/content-type/Tab.plugin.js'),
require('./../../../../packages/scandiweb-adobe-page-builder/src/plugin/html/HtmlComponent.plugin.js')]);
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import 'Util/Polyfill';
import 'Style/main';

import { render } from 'react-dom';

import App from 'Component/App';

// let's register service-worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        const swUrl = '/service-worker.js';

        navigator.serviceWorker.register(swUrl, { scope: '/' });
    });
}

render(<App />, document.getElementById('root'));
